import { flexRender, Table } from "@tanstack/react-table";
import { ReactNode } from "react";

import Styled from "./styles";

interface EarlyWarningTableMapTableProps {
  table: Table<{
    [date: string]: ReactNode;
    phenomenom: string;
  }>;
  selectedDay: number;
  setSelectedDay: (index: number) => void;
  variant?: "inline" | "block";
}

const EarlyWarningMapTable = ({
  table,
  selectedDay,
  setSelectedDay,
}: EarlyWarningTableMapTableProps) => {
  return (
    <Styled.TableElement>
      <Styled.TableWrapper>
        <Styled.Table>
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <Styled.Row key={headerGroup.id}>
                {headerGroup.headers.map((header, index) => (
                  <Styled.HeaderCell
                    key={header.id}
                    colSpan={header.colSpan}
                    selected={selectedDay === index - 1}
                    variant="inline"
                    onClick={() => index > 0 && setSelectedDay(index - 1)}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(header.column.columnDef.header, header.getContext())}
                  </Styled.HeaderCell>
                ))}
              </Styled.Row>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <Styled.Row key={row.id}>
                {row.getVisibleCells().map((cell, index) => (
                  <Styled.BodyCell
                    key={cell.id}
                    selected={selectedDay === index - 1}
                    variant="inline"
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </Styled.BodyCell>
                ))}
              </Styled.Row>
            ))}
          </tbody>
        </Styled.Table>
      </Styled.TableWrapper>
    </Styled.TableElement>
  );
};

export default EarlyWarningMapTable;
